var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1551_23888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.74 4V18C18.74 19.1 17.83 20 16.72 20H2.58C1.45 20 0.559998 19.1 0.559998 18L0.569998 4C0.569998 2.9 1.45 2 2.58 2H3.59V0H5.61V2H13.69V0H15.71V2H16.72C17.83 2 18.74 2.9 18.74 4ZM16.72 7H2.58V18H16.72V7ZM4.6 9H9.65V14H4.6V9Z",
    fill: "#08BBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1551_23888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3db0958240ea431ca0c30e54fae61b6d.svg";
export { ForwardRef as ReactComponent };